import React from 'react'

import logo from "../../assets/logoCompany.svg"
import icon from "../../assets/Group.svg"

const Competitors = ({ t }) => {

    return (
        <section className=' d-none d-md-block container-xl'>
            <h3 className='text-center'>Sky-high company savings</h3>
            <p className='text-center '>Flights, hotels, trains, cars—organize work travel in just a few clicks with the all-in-one platform everyone can use.</p>
            <div className='row justify-content-between mt-5'>
                <div
                    className="col-3 rounded-5 overflow-hidden position-relative text-white"
                    style={{
                        minHeight: "220px",
                        backgroundImage:
                            "url('https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1200&auto=format&fit=crop')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}>
                    {/* Overlay */}
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            background:
                                "linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.2))",
                        }}
                    />

                    {/* Content */}
                    <div className="position-relative h-100 p-4 d-flex flex-column justify-content-between">
                        <p className="fw-bold mb-0 fs-3">El Comparador</p>

                        <p className="mb-0 "><p className='fw-bold fs-2 mb-0'>36 %</p>expense savings</p>
                    </div>
                </div>
                <div className='col-5 rounded-5 p-3 bg-white shadow-sm d-flex flex-column align-items-center justify-content-center'>
                    <img src={logo}  width="100"  className='my-4'/>
                    <p className='text-center fw-medium fs-6 text-primary-blue'>"{t("witness_caption")} <span className='text-blue fst-italic'>{t("increasing")}</span> {t("visibility")}"</p>
                    <div className='text-center'>
                        <p className='mb-0 fw-bold'>Amanda Kim</p>
                    <p className='mt-0 fw-medium'>Sales Executive</p>
                    </div>
                </div>
                 <div
                    className="col-3 rounded-5  bg-blue text-white d-flex flex-column justify-content-evenly align-items-center"
                  
                >
                  
<img src={icon} width={100} className=''/>
<p className='my-0 text-center' style={{width:"200px"}}>{t("Up to 90% on expense automation")}</p>
                  
                </div>
            </div>


        </section>
    )
}

export default Competitors
